module.exports = __webpack_public_path__ + "img/courier-dhl.192bdcbd.svg";